import React from "react"
import { useParams } from "react-router-dom"
import TransfersListing from "../../../components/Listing/TransfersListing"

/**
 * Admin City Transfers listing — Figma Manage City - Transfers Listing.
 */
const AdminCityTransfers = () => {
  const { cityId } = useParams()

  return (
    <TransfersListing
      documentTitle="City Transfer Requests | AMOK . EARTH Admin"
      cityId={cityId}
      showExport
    />
  )
}

export default AdminCityTransfers
